export default function FullTimeIco() {
  return (
    <svg
      width="10"
      height="15"
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.66522 5C4.69247 4.97562 4.7187 4.94948 4.74376 4.92159L7.0482 2.35568C7.62636 1.71192 7.16948 0.6875 6.3042 0.6875H1.69532C0.830049 0.6875 0.373163 1.71192 0.951324 2.35568L3.25577 4.92159C3.28082 4.94948 3.30705 4.97562 3.33431 5C3.30705 5.02438 3.28082 5.05052 3.25577 5.07841L0.951324 7.64432C0.373163 8.28808 0.830049 9.3125 1.69532 9.3125H6.3042C7.16948 9.3125 7.62636 8.28808 7.0482 7.64432L4.74376 5.07841C4.7187 5.05051 4.69247 5.02438 4.66522 5Z"
        fill="#F31DED"
      />
    </svg>
  );
}
